import React from 'react';
import { withIcon, SvgIconProps } from '../../../../components/withIcon';

const SvgPercentageOutlined = ({ size, title = 'PercentageOutlined', ...props }: SvgIconProps): JSX.Element => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        fill="none"
        viewBox="0 0 24 24"
        width={size}
        height={size}
        data-icon-name={title}
        aria-label={title}
        role="presentation"
        {...props}
    >
        <path
            stroke="currentColor"
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={1.5}
            d="M7 18.5l10-13m-8.5 5a2.5 2.5 0 100-5 2.5 2.5 0 000 5zm7 8a2.5 2.5 0 100-5 2.5 2.5 0 000 5z"
        />
    </svg>
);

export default withIcon(SvgPercentageOutlined);
